import { getAxisCoordinates } from '../helpers';

export default function RadialGrid({ configuration, vizSize, scale, largest }) {
  const maxTicks = 20;

  // Used when radialGrid.size is unassigned to automatically create good tick values to fit ~4 ticks.
  // Rounding of the most signifigant digit
  function tickRounder(value, split) {
    if (value === 0) {
      return 0;
    }
    return (
      Math.round((value / split) * 10 ** Math.ceil(-Math.log10(value / split))) /
      10 ** Math.ceil(-Math.log10(value / split))
    );
  }

  const forceAutomaticTicks =
    Math.ceil(
      vizSize > 0 ? Math.sqrt(vizSize ** 2 * 2) / 2 / (configuration.radialGrid.size * scale) : 0
    ) > maxTicks;

  const tick =
    configuration.radialGrid?.size && !forceAutomaticTicks
      ? configuration.radialGrid.size * scale
      : tickRounder(largest, 4) * scale;

  const tickAmount = Math.ceil(vizSize > 0 ? Math.sqrt(vizSize ** 2 * 2) / 2 / tick : 0);

  function Axis({ coords }) {
    return (
      <line
        className="grid-axis"
        x1={vizSize / 2}
        y1={vizSize / 2}
        x2={vizSize / 2 + coords[0]}
        y2={vizSize / 2 + coords[1]}
      />
    );
  }

  return (
    <g className="star-grid">
      {Array.from({ length: configuration.radialGrid?.axes }).map((vector, index) => (
        <Axis
          key={index}
          coords={getAxisCoordinates({
            axisValues: Array.from({ length: configuration.radialGrid?.axes }).map((v, index_) =>
              index === index_ ? 500 : 0
            ),
          })}
        />
      ))}

      {tick > 0 &&
        Array.from({ length: tickAmount }).map((c, index) => (
          <circle
            className="grid-radius"
            key={index}
            cx="50%"
            cy="50%"
            r={tick * index}
          />
        ))}
      <line
        className="grid-axis-line"
        x1={vizSize / 2}
        y1={vizSize / 2}
        x2={0}
        y2={vizSize / 2}
      />
      {tick > 0 &&
        Array.from({ length: tickAmount }).map((t, index) => (
          <g key={index}>
            <line
              x1={vizSize / 2 - tick * index}
              y1={vizSize / 2 - 5}
              x2={vizSize / 2 - tick * index}
              y2={vizSize / 2}
              className="grid-tick"
            />
            <g>
              <text
                className="star-grid-text"
                x={vizSize / 2 - tick * index}
                y={vizSize / 2 + 2}
                style={{
                  transformOrigin: `${vizSize / 2 - tick * index}px ${vizSize / 2 + 2}px`,
                  rotate: '90deg',
                  translate: '-3px 2px',
                }}
              >
                {configuration.radialGrid?.size && !forceAutomaticTicks
                  ? configuration.radialGrid.size * index
                  : Number.parseFloat(Number.parseFloat((tick / scale) * index).toPrecision(10))}
              </text>
            </g>
          </g>
        ))}
    </g>
  );
}
